import { levelSelectors } from '~/store';
// ---- internal imports ----

import { LEVEL_CREATE_NEW_GAME } from '../actionTypes';
// ---- parent imports ----

import setupLevel from './setupLevel';
// ---- local imports ----


function setUpFirstLevelForNewGame() {
	return async (dispatch, getState) => {
		const missions = setupLevel(getState(), 1);
		const levelData = levelSelectors.getLevelData(getState(), 0);

		dispatch({
			type: LEVEL_CREATE_NEW_GAME,
			level: 1,
			missions,
			story: levelData.story,
			featuresToUnlock: levelData.featuresToUnlock,
		});
	};
}


export default setUpFirstLevelForNewGame;
